import {getExtraDataSimple} from '../../utils/WizardMXBodyMapper';
import {ofType} from 'redux-observable';
import * as WizardActions from '../../actions/WizardActions';
import {catchError, mergeMap, timeout} from 'rxjs/operators';
import {AnyAction} from 'redux';
import {concat, iif, of} from 'rxjs';
import * as MC from '../../constants/MotorcreditConstants';
import {COUNTRIES} from '../../constants/AppConstants';
import * as UIActions from '../../actions/UIActions';
import {addCredentialAndExecute} from '../../utils/RetryUtil';
import {ajax} from 'rxjs/ajax';
import {processApiError} from '../../utils/ApiUtil';
import {BankTarget} from '../../types/mx/types';
import * as CRValidationIdActions from '../../actions/CRValidationIdActions';
import * as FileTypeConstants from '../../../common/constants/FileTypeConstants';
import {MODAL_TYPE} from '../../constants/ModalConstants';
import * as ModalActions from '../../../wizard-seminuevos/actions/ModalActions';

const mapDocumentCreditoReal = (file, documentType, section, ownerName, state) => {
    const data = new FormData();
    data.append('docType', documentType);
    data.append('ownerName', ownerName);
    data.append('file', file);
    data.append('section', section);
    if (documentType !== FileTypeConstants.PROOF_OF_TAX_STATUS_TYPE && section !== FileTypeConstants.WORK_SECTION) {
        data.append('extraData', JSON.stringify(getExtraDataSimple(8, state)));
    }
    return data;
};

const mapDocumentTurboCash = (file, documentType, section, ownerName, state) => {
    const data = new FormData();
    data.append('docType', documentType);
    data.append('ownerName', ownerName);
    data.append('file', file);
    data.append('section', section);
    return data;
};

export const processFilesToUploadAction = (action$, state$) =>
    action$.pipe(
        ofType(WizardActions.PROCESS_FILES_TO_UPLOAD_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const ownerName = `${state.profile.firstName} ${state.profile.lastName}`;
            const file = action.bank === BankTarget.CREDITO_REAL_STATE ?
                mapDocumentCreditoReal(action.files.pop(), action.fileType, action.fileSection, ownerName, state) :
                mapDocumentTurboCash(action.files.pop(), action.fileType, action.fileSection, ownerName, state);
            return of(WizardActions.UPLOAD_FILES_ACTION.action(file, action.bank, action.fileType));
        })
    );

export const deleteFileAction = (action$, state$) => {
    return action$.pipe(
        ofType(WizardActions.DELETE_FILE_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const bank = action.bank;
            const token = state[bank].loanApplication.token ? `/${state[bank].loanApplication.token}` : '';
            const bankSelected = bank === BankTarget.CREDITO_REAL_STATE ?
                BankTarget.CREDITO_REAL : BankTarget.TURBO_CASH;
            const server = MC.MCC_URL_WITH_BANK(COUNTRIES.MX.id, bankSelected);
            const url = `${server}/loan-applications${token}/docs/${action.fileId}?doctype=${action.fileType}`;

            return concat(
                of(UIActions.IS_LOADING_ACTION.action(WizardActions.UPLOAD_FILES_ACTION.name)),
                addCredentialAndExecute(headers => ajax.delete(url, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        console.log('------------------WizardMXActions.RETURNED_FROM_API----------------- ', response);

                        return concat(
                            of(refreshTokenObs),
                            iif(
                                () => bank === BankTarget.CREDITO_REAL_STATE,
                                of(WizardActions.UPLOADED_FILES_ACTION.action(response.response.data)),
                                of(WizardActions.UPLOADED_FILES_TC_ACTION.action(response.response.data))
                            ),
                            of(UIActions.IS_LOADED_ACTION.action(WizardActions.UPLOAD_FILES_ACTION.name))
                        );
                    }),
                    catchError((error) => {
                        console.log('---------- EROROROROROOROR ::: ', error);

                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(WizardActions.UPLOAD_FILES_ACTION.name),
                            UIActions.ERROR_GENERAL_ACTION.action(error, action, url, {}, 'DELETE')
                        ])(error);
                    })
                )
            );
        }));
};

export const uploadFilesAction = (action$, state$) => {
    return action$.pipe(
        ofType(WizardActions.UPLOAD_FILES_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const bank = action.bank;
            const bankSelected = bank === BankTarget.CREDITO_REAL_STATE ?
                BankTarget.CREDITO_REAL : BankTarget.TURBO_CASH;
            const token = state[bank].loanApplication.token ? `/${state[bank].loanApplication.token}` : '';
            const server = MC.MCC_URL_WITH_BANK(COUNTRIES.MX.id, bankSelected);
            const url = `${server}/loan-applications${token}/docs-multipart`;
            const data = action.files;
            return concat(
                of(UIActions.IS_LOADING_ACTION.action(WizardActions.UPLOAD_FILES_ACTION.name)),
                addCredentialAndExecute(
                    headers => ajax.put(url, data, headers), state$.value, false, 'multipart/form-data').pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        console.log('------------------WizardMXActions.RETURNED_FROM_API---------------- ', response);

                        return concat(
                            of(refreshTokenObs),
                            // of(
                            //     LoanApplicationActions.SET_HIGHEST_STEP_ACTION.action(response.response.data.step)
                            // ),
                            iif(
                                () => bank === BankTarget.CREDITO_REAL_STATE,
                                concat(
                                    of(WizardActions.UPLOADED_FILES_ACTION.action(response.response.data)),
                                    of(CRValidationIdActions.CR_SHOULD_SEND_TO_ID_VALIDATION_ACTION.action(
                                        action.bank, action.fileType
                                    )),
                                ),
                                of(WizardActions.UPLOADED_FILES_TC_ACTION.action(response.response.data))
                            ),
                            of(UIActions.IS_LOADED_ACTION.action(WizardActions.UPLOAD_FILES_ACTION.name))
                        );
                    }),
                    catchError((error) => {
                        console.log('---------- EROROROROROOROR ::: ', error);
                        const content = {
                            type: MODAL_TYPE.SHOW_FILE_FAILED_UPLOAD_VIEW
                        };
                        const options = {
                            closeOnOverlayClick: false
                        };
                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(WizardActions.UPLOAD_FILES_ACTION.name),
                            ModalActions.OPEN_MODAL_DATA_ACTION.action(null, content, null, options)
                        ])(error);
                    })
                )
            );
        }));
};
